import React, { useState, createContext } from "react";
import departementData from "./DepartementsData";

export const DepartementContext = createContext();

export const DepartementContextProvider = (props) => {
    const [data, setData] = useState(departementData);

    return <DepartementContext.Provider value={{contextData: [data, setData] }}>{props.children}</DepartementContext.Provider>
}